import { useState } from 'react';
import { PROJECTS_LIST } from '../../../mocks/auth';
import { useCabinet } from '../useCabinet';
import { getScoped, setScoped } from '../../../lib/storage';

const LS_KEY = 'saved_project';

export default function MyProjects() {
  const { scope } = useCabinet();
  const [selected, setSelected] = useState<string | null>(() => getScoped(scope, LS_KEY));
  const [saved, setSaved] = useState<string | null>(() => getScoped(scope, LS_KEY));
  const [showSuccess, setShowSuccess] = useState(false);

  function handleToggle(id: string) {
    setSelected((prev) => (prev === id ? null : id));
  }

  function handleSave() {
    if (!selected) return;
    setSaved(selected);
    setScoped(scope, LS_KEY, selected);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  }

  return (
    <div className="max-w-4xl relative">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мои проекты</h2>
        <p className="text-foreground-500 text-sm">Выберите направление, в котором будете работать</p>
      </div>

      {/* Success toast */}
      {showSuccess && (
        <div className="fixed top-6 right-6 z-50 flex items-center gap-3 bg-primary-500/95 text-white rounded-2xl px-5 py-4 shadow-lg animate-pulse max-w-sm">
          <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-checkbox-circle-fill text-lg" />
          </span>
          <p className="text-sm font-medium leading-snug">
            Мы зафиксировали Ваш выбор проекта. Вы сможете поменять его в будущем. Финальное закрепление происходит после оформления.
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {PROJECTS_LIST.map((project) => {
          const isSelected = selected === project.id;
          const isSaved = saved === project.id;
          return (
            <div
              key={project.id}
              onClick={() => handleToggle(project.id)}
              className={`relative bg-[#0e0e11] border rounded-2xl p-6 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 ${
                isSelected
                  ? 'border-primary-500/50 bg-primary-500/5'
                  : 'border-[#18181c] hover:border-[#26262c]'
              }`}
            >
              <div className="flex items-start gap-4">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ background: `${project.color}18`, border: `1px solid ${project.color}30` }}
                >
                  <i className={`${project.icon} text-xl`} style={{ color: project.color }} />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <h3 className="text-sm font-bold text-white">{project.title}</h3>
                    {isSaved && (
                      <span className="text-xs text-primary-300 bg-primary-500/10 border border-primary-500/20 rounded-full px-2 py-0.5 whitespace-nowrap">
                        Текущий
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{project.description}</p>
                </div>

                <div className={`w-5 h-5 rounded-md flex-shrink-0 flex items-center justify-center border transition-all duration-200 mt-0.5 ${
                  isSelected
                    ? 'bg-primary-600 border-primary-500'
                    : 'border-[#26262c] bg-[#141417]'
                }`}>
                  {isSelected && <i className="ri-check-line text-white text-xs" />}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between bg-[#0e0e11] border border-[#18181c] rounded-2xl px-6 py-4">
        <p className="text-sm text-foreground-500">
          {selected
            ? `Выбрано: ${PROJECTS_LIST.find((p) => p.id === selected)?.title}`
            : 'Проект не выбран'}
        </p>
        <button
          onClick={handleSave}
          disabled={!selected || selected === saved}
          className="bg-primary-600 hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold rounded-xl px-6 py-2.5 text-sm transition-all cursor-pointer whitespace-nowrap"
        >
          Сохранить выбор
        </button>
      </div>
    </div>
  );
}
